import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  sidebarWrapper: (props: any) => ({
    overflowY: 'auto',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: 10,
      background: props.filterBackgroundColor,
    },
    [theme.breakpoints.up(1920)]: {
      minWidth: '260px',
    },
    [theme.breakpoints.up(2000)]: {
      minWidth: '300px',
    },
    [theme.breakpoints.up(3000)]: {
      minWidth: '380px',
    },
  }),
  popoverContent: {
    width: '100%',
    padding: '10px',
  },
  contentHoverGroup: {
    borderRadius: '10px',
    padding: '10px',
    [theme.breakpoints.up('md')]: {
      '&:hover': {
        '-webkit-box-shadow': `0px 0px 5px 0px ${theme.palette.primary.main}`,
        '-moz-box-shadow': `0px 0px 5px 0px ${theme.palette.primary.main}`,
        'box-shadow': `0px 0px 5px 0px ${theme.palette.primary.main}`,
      },
      '&:hover $wrapperLayoutStyles': {
        'box-shadow': 'none',
      },
    },
  },
  popoverContentActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // The heart sits in this row (same line as the close arrow); its default
    // card-corner placement is position:absolute — anchor it into the row and
    // keep the same right offset it had on the card.
    '& [data-gaid="favoriteBtn"]': {
      position: 'static',
      marginRight: '5px',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
  },
  wrapperLayoutStyles: {
    '&:hover': {
      top: '0px !important',
    },
  },
  wrapperOpen: {
    animation: '$wrapperOpen 400ms forwards',
    [theme.breakpoints.up(1920)]: {
      animation: '$wrapperOpen 400ms forwards',
    },
    [theme.breakpoints.up(2000)]: {
      animation: '$wrapperOpen_300 400ms forwards',
    },
    [theme.breakpoints.up(3000)]: {
      animation: '$wrapperOpen_380 400ms forwards',
    },
    [theme.breakpoints.down('md')]: {
      animation: '$wrapperOpenPhone 400ms forwards',
    },
  },
  wrapperClose: {
    animation: '$wrapperClose 400ms forwards',
    [theme.breakpoints.up(1920)]: {
      animation: '$wrapperClose 400ms forwards',
    },
    [theme.breakpoints.up(2000)]: {
      animation: '$wrapperClose_300 400ms forwards',
    },
    [theme.breakpoints.up(3000)]: {
      animation: '$wrapperClose_380 400ms forwards',
    },
    [theme.breakpoints.down('md')]: {
      animation: '$wrapperOpenPhone 400ms forwards',
    },
    [theme.breakpoints.down('md')]: {
      animation: '$wrapperClosePhone 400ms forwards',
    },
  },
  '@keyframes wrapperOpen': {
    '0%': { width: '0px', minWidth: '0px' },
    '100%': { width: '260px', minWidth: '260px' },
  },
  '@keyframes wrapperOpen_300': {
    '0%': { width: '0px', minWidth: '0px' },
    '100%': { width: '300px', minWidth: '300px' },
  },
  '@keyframes wrapperOpen_380': {
    '0%': { width: '0px', minWidth: '0px' },
    '100%': { width: '380px', minWidth: '380px' },
  },

  '@keyframes wrapperClose': {
    '0%': { width: '260px', minWidth: '260px' },
    '100%': { width: '0px', minWidth: '0px' },
  },
  '@keyframes wrapperClose_300': {
    '0%': { width: '300px', minWidth: '300px' },
    '100%': { width: '0px', minWidth: '0px' },
  },
  '@keyframes wrapperClose_380': {
    '0%': { width: '380px', minWidth: '380px' },
    '100%': { width: '0px', minWidth: '0px' },
  },
  '@keyframes wrapperOpenPhone': {
    '0%': { width: '0px' },
    '100%': { width: '100%' },
  },
  '@keyframes wrapperClosePhone': {
    '0%': { width: '100%' },
    '100%': { width: '0px' },
  },
}));
